<template>
  <div style="width: 70%" class="flex-col-start-start gap-4">
    <div class="text-h5 font-weight-bold white--text">
      {{ $t("welcome_note") }}
    </div>
    <v-form ref="loginForm" class="w-100">
      <div class="flex-col-start-start gap-2">
        <div class="text-caption white--text">{{ $t("username") }}*</div>
        <v-text-field
          solo
          flat
          :rules="[rules.required]"
          v-model="formData.username"
          @focus="isError = false"
          required
          class="w-100"
          dir="ltr"
        />
      </div>
      <div class="flex-col-start-start gap-2">
        <div class="text-caption white--text">{{ $t("password") }}*</div>
        <v-text-field
          solo
          flat
          background-color="white"
          :rules="[rules.required]"
          :prepend-inner-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPass ? 'text' : 'password'"
          v-model="formData.password"
          @click:prepend-inner="showPass = !showPass"
          @focus="isError = false"
          required
          class="w-100"
          dir="ltr"
        />
      </div>
      <v-btn
        color="secondaryYellow"
        class="black--text"
        min-width="150"
        :loading="loading"
        @click="submit"
      >
        {{ $t("login") }}
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";
import { ROUTES } from "@/routes/pwa";
import { LOGIN } from "@/core/services/store/modules/user/user.module";
import { VALIDATION_RULES } from "@/core/constants";

export default {
  name: "LoginForm",

  data() {
    return {
      showPass: false,
      rules: VALIDATION_RULES,
      formData: {
        username: undefined,
        password: undefined,
      },
      loading: false,
    };
  },

  methods: {
    async submit() {
      const isValid = this.$refs.loginForm.validate();

      if (isValid) {
        this.loading = true;
        await this.$store
          .dispatch(LOGIN, this.formData)
          .then(() => {
            const returnPath = this.$route.query["return-path"];
            this.$router.replace(returnPath ?? ROUTES.prediction);
            this.$store.commit(SET_ALERT, {
              text: this.$t("login_successful"),
              isError: false,
            });
          })
          .catch((error) => {
            this.$store.commit(SET_ALERT, {
              text: error.message,
              isError: true,
            });
          });
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.v-input__slot {
  width: 100% !important;
}
</style>
